/** PowerMeterContractDetail 계약 목록과 공유하는 유틸·배지 */

export function getOpmContractNumber(row) {
  return row?.ContractNumber ?? row?.contractNumber ?? '';
}

export function getDataEndDateString(row) {
  return row?.DataEndDate ?? row?.dataEndDate ?? null;
}

/** YYYY-MM-DD 또는 파싱 가능한 문자열 → 로컬 자정 기준 Date */
export function parseDateOnlyLocal(str) {
  if (str == null || str === '') return null;
  const s = String(str).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const d = parseInt(m[3], 10);
    const dt = new Date(y, mo, d);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }
  const t = new Date(s);
  return Number.isNaN(t.getTime()) ? null : t;
}

/** 종료일: 지남 → expired, 오늘~30일 이내 → soon */
export function getEndDateHighlightClass(endStr) {
  const end = parseDateOnlyLocal(endStr);
  if (!end) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  const diffDays = (endDay.getTime() - today.getTime()) / (86400 * 1000);
  if (diffDays < 0) return 'opm-end-date--expired';
  if (diffDays <= 30) return 'opm-end-date--soon';
  return '';
}

export function matchesConnectFilter(row, connectFilter) {
  if (connectFilter === 'connected') return row?.ConnectStatus === true;
  if (connectFilter === 'disconnected') return row?.ConnectStatus !== true;
  return true;
}

/** 정산대상 필터: 전체 | 대상 | 비대상 */
export function matchesSettlementTargetFilter(row, settlementTargetFilter) {
  if (settlementTargetFilter === 'target') return row?.IsSettlementTarget === true;
  if (settlementTargetFilter === 'nonTarget') return row?.IsSettlementTarget !== true;
  return true;
}

function getConnectBadgeInfo(connect) {
  if (connect === true) {
    return { text: '제공', color: '#29D668', dotColor: '#29D668', bgColor: '#E5FAEA' };
  }
  if (connect === false) {
    return { text: '미제공', color: '#FEC02E', dotColor: '#FEC02E', bgColor: '#FFFDE7' };
  }
  return { text: '—', color: 'var(--gray-600)', dotColor: 'var(--gray-400)', bgColor: 'var(--gray-100)' };
}

function StatusPill({ text, color, dotColor, bgColor }) {
  return (
    <div className="opm-status-pill" style={{ backgroundColor: bgColor }}>
      <span className="opm-status-pill__dot" style={{ backgroundColor: dotColor }} />
      <span className="opm-status-pill__text" style={{ color }}>
        {text}
      </span>
    </div>
  );
}

export function ConnectStatusBadge({ connect }) {
  const info = getConnectBadgeInfo(connect);
  return <StatusPill {...info} />;
}
